import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { QuestionBaseComponent } from '@core/form-generator-engine/abstractions';
import { QuestionControl } from '@core/form-generator-engine/composite-pattern';
import { timer } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gstar-percent',
  templateUrl: './percent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PercentComponent implements AfterViewInit, QuestionBaseComponent {
  @Input() question!: QuestionControl;

  @ViewChild('field', { static: false })
  field!: { cdr: ChangeDetectorRef };

  ngAfterViewInit(): void {
    timer(0).subscribe(() => {
      this.field.cdr.detectChanges();
    });
  }
}
